// Read more / read less function
// function readMore() {
//   var dots = document.getElementById("dots");
//   var moreText = document.getElementById("more");
//   var btnText = document.getElementById("read-more-js");

//   if (dots.style.display === "none") {
//     dots.style.display = "inline";
//     btnText.innerHTML = "read more";
//     moreText.style.display = "none";
//   } else {
//     dots.style.display = "none";
//     btnText.innerHTML = "read less";
//     moreText.style.display = "inline";
//   }
// }
window.addEventListener('load', () => {
  const carousel = document.querySelector('.product-gallery__carousel');
  const thumbnailScroller = document.querySelector('.product-gallery__thumbnail-scroller');

  if (carousel && thumbnailScroller) {
      const carouselHeight = carousel.offsetHeight;
      thumbnailScroller.style.maxHeight = `${carouselHeight}px`;
  }
});

window.addEventListener('resize', () => {
  const carousel = document.querySelector('.product-gallery__carousel');
  const thumbnailScroller = document.querySelector('.product-gallery__thumbnail-scroller');

  if (carousel && thumbnailScroller) {
      const carouselHeight = carousel.offsetHeight;
      thumbnailScroller.style.maxHeight = `${carouselHeight}px`;
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const scroller = document.querySelector(".product-gallery__thumbnail-scroller");
  const prevBtn = document.querySelector(".product-gallery__thumbnail-prev");
  const nextBtn = document.querySelector(".product-gallery__thumbnail-next");

  if (!scroller || !prevBtn || !nextBtn) return;

  prevBtn.addEventListener("click", () => {
    const activeItem = scroller.querySelector('[aria-current="true"]');
    if (activeItem && activeItem.previousElementSibling) {
        activeItem.previousElementSibling.click();
    }
  });

  nextBtn.addEventListener("click", () => {
    const activeItem = scroller.querySelector('[aria-current="true"]');
    if (activeItem && activeItem.nextElementSibling) {
        activeItem.nextElementSibling.click();
    }
  });
});
